import axios from "axios";
import { firebaseInstance } from "../firebase/firebaseInstance";

const instance = axios.create();

instance.defaults.baseURL = process.env.REACT_APP_FUNCTION_ENDPOINT;

instance.interceptors.request.use(async (request) => {
  const token = await firebaseInstance.auth().currentUser?.getIdToken();
  request.headers["Authorization"] = `Bearer ${token}`;

  return request;
});

export default instance;
